<template>
	<form @submit.prevent="login()">
		<div class="row d-flex justify-content-around">
			<div class="form-group col-sm-12">
				<BaseInput
					name="Email"
					type="email"
					v-model="user.email"
					rules="required|email"
					class="formInputs form-control form-control-lg change-input"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-12">
				<BaseInput
					name="Password"
					type="password"
					v-model="user.password"
					rules="required|min:3"
					class="formInputs form-control form-control-lg change-input"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-12">
				<BaseButton
					class="btn form-control loginBtn"
					type="submit"
					label="Login"
					:disabled="formState.disable"
					:loading="formState.isLoading"
				/>
			</div>
		</div>
	</form>
</template>

<script>
	import { ref, reactive, inject } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import BaseInput from "@/components/BaseInput";
	import BaseButton from "@/components/BaseButton";
	import toast from "@/config/toast";

	export default {
		name: "AuthLogin",
		components: {
			BaseInput,
			BaseButton,
		},
		setup: () => {
			const store = inject("store");

			const router = useRouter();

			if (store.state.auth.isAuth) router.push({ name: "Dashboard" });

			const user = reactive({
				email: null,
				password: null,
			});

			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: [],
			});

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const login = async () => {
				changeFormLoadingState();
				formState.disable = true;

				if (validation.invalid.length) {
					toast.error("Incomplete form", true);
					changeFormLoadingState();
					return;
				}

				try {
					let response = await API.generalRequest.post("auth/login", user);

					toast.success(
						{ message: "Login Success!", position: "topRight" },
						true,
					);
					changeFormLoadingState();
					await store.methods.transformAndSetUser(response.data.data[0]);
					await store.methods.saveState();
					router.push({ name: "Dashboard" });
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					changeFormLoadingState();
					formState.disable = false;
				}
			};

			//? checking conditions to enable or disable form login button
			const checkForm = () => {
				let valLength = validation.valid.length;
				let inValLength = validation.invalid.length;
				let formLength = Object.keys(user).length;
				let formInputs = Object.keys(user); //!formInputs should be in formState
				let nullables = Object.values(validation.nullable);
				let notNullable = [];

				for (let nullable of nullables) {
					for (let [index, formInput] of formInputs.entries()) {
						if (nullable === formInput) {
							delete formInputs[index];
							break;
						} else if (!formInput) break;
						else notNullable.push(formInput);
					}
				}
				notNullable = [...new Set(notNullable)];

				let notNullableInvalids = notNullable.flatMap((item) => {
					let catchInValid = validation.invalid.includes(item);
					return catchInValid;
				});

				//? removing falsy values from array
				let check = notNullableInvalids.filter(Boolean);

				if (
					!inValLength &&
					!check.length &&
					valLength + notNullable.length >= formLength
				) {
					formState.disable = false;
				} else formState.disable = true;
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			// event handler for valError event
			const valError = (data) => {
				setFormVal(data);
				validation.invalid = [...validation.invalid, data];
				checkForm();
			};

			const valSuccess = (data) => {
				setFormVal(data);
				validation.valid = [...validation.valid, data];
				checkForm();
			};

			return { user, login, valError, valSuccess, validation, formState };
		},
	};
</script>


